module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: [!_vm.comments_tab ? 'cursor-pointer' : ''],
    attrs: {
      "id": ("recap-card-" + (_vm.genieRecap.id))
    },
    on: {
      "click": _vm.openCommentsAndSideBar
    }
  }, [_c('div', {
    staticClass: "mb-2 flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('Tooltip', {
    attrs: {
      "text": "See how the Genie summarized this conversation, and share any other thoughts you have on this topic!",
      "styleTooltip": "top-0 left-full ml-2"
    }
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('img', {
    staticClass: "avatar mr-3 w-7 h-7 rounded-full",
    attrs: {
      "src": "/static/roundtable_options_create/genie_icon.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mr-2 text-sm font-semibold font-poppins text-gray-800"
  }, [_vm._v(" Genie Recap ")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-600"
  }, [_vm._v(_vm._s(_vm.recapDateTtimeAgo))])])]), _vm._v(" "), (_vm.comments_tab) ? _c('Tooltip', {
    attrs: {
      "text": "Collapse",
      "padding": "px-3 py-1.5",
      "styleTooltip": "top-0 left-full -mt-1.5 ml-2"
    }
  }, [_c('button', {
    staticClass: "w-8 h-8 hover:bg-gray-200 rounded-full ml-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.collapseGenieCard.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-up"
  })])]) : _vm._e()], 1), _vm._v(" "), (_vm.genieRecap.id) ? _c('div', {
    staticClass: "flex items-center"
  }, [(_vm.genieRecap.submissions_count < _vm.submissions) ? _c('Tooltip', {
    attrs: {
      "text": ("Summary generated from " + (_vm.genieRecap.submissions_count) + " of " + _vm.submissions + " existing submissions. Regenerate to include all submissions."),
      "padding": "px-3 py-1.5",
      "styleTooltip": "top-0 right-full -mt-1.5 mr-2"
    }
  }, [_c('span', {
    staticClass: "text-xs text-gray-600"
  }, [_vm._v("\n            Summarized " + _vm._s(_vm.genieRecap.submissions_count) + " of\n            " + _vm._s(_vm.submissions) + " submissions\n          ")])]) : _c('span', {
    staticClass: "text-xs text-gray-600"
  }, [_vm._v("\n          Summarized " + _vm._s(_vm.genieRecap.submissions_count) + " of\n          " + _vm._s(_vm.submissions) + " submissions\n        ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('pl-menu', {
    staticClass: "ml-1 z-10",
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('button', {
    staticClass: "w-8 h-8 rounded-full hover:bg-blueGray-100",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-v text-sm text-gray-500"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "px-1 py-1",
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    staticClass: "sample rounded py-1.5 px-2.5 cursor-pointer w-full flex space-x-2 items-center hover:bg-coolGray-100",
    on: {
      "click": function($event) {
        return _vm.editRecap()
      }
    }
  }, [_c('span', {
    staticClass: "text-blueGray-700",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Edit Recap")])]), _vm._v(" "), _c('li', {
    staticClass: "sample rounded py-1.5 px-2.5 cursor-pointer w-full flex space-x-2 items-center hover:bg-red-50",
    on: {
      "click": function($event) {
        return _vm.handleDeleteRecap()
      }
    }
  }, [_c('span', {
    staticClass: "text-red-500",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Delete")])])])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ml-11"
  }, [_c('div', [_c('div', [_c('div', [(Object.keys(_vm.genieRecap).length > 0 && _vm.genieRecap.prompt_summary !== '' && _vm.genieRecap.questions.length > 0) ? _c('div', [_c('h6', {
    staticClass: "mb-4 font-poppins font-semibold text-blueGray-800 antialiased"
  }, [_vm._v("\n                Here's a summary of all the different ideas in our class:\n              ")]), _vm._v(" "), _c('div', {
    class: _vm.loading ? 'line-through' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.genieRecap.prompt_summary)
    }
  })]) : _c('h6', {
    staticClass: "mb-4 text-blueGray-800 antialiased"
  }, [_vm._v("\n              Ask the Genie to summarize insights from all\n              " + _vm._s(_vm.submissions) + " of the submissions in this RoundTable!\n            ")])]), _vm._v(" "), _c('div', [(_vm.hasTeacherPermissionsInCourse && (Object.keys(_vm.genieRecap).length === 0 || _vm.loading === true)) ? _c('div', [_c('button', {
    staticClass: "sample flex space-x-2.5 items-center px-5 py-2 bg-pink-50 border border-solid border-pink-300 rounded text-xs text-pinky font-semibold hover:bg-pinky-new_light",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.generateGenieRecap.apply(null, arguments)
      }
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader -ml-1.5"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.loading ? 'Generating...' : 'Generate Recap'))])])]) : _c('div', [_c('div', {
    staticClass: "flex pt-5"
  }, [_c('button', {
    staticClass: "sample mr-2 px-5 py-2 bg-gray-100 border-blueGray-300 border hover:bg-blueGray-600 hover:border-blueGray-600 hover:text-blueGray-100 border-solid rounded text-xs font-semibold",
    class: [_vm.comments_tab ? 'bg-blueGray-600 text-blueGray-100 border-blueGray-600' : 'text-gray-400'],
    attrs: {
      "id": "recap-comments"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.getRecapComments.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                  Comments (" + _vm._s(_vm.genieRecap.comment_count) + ")\n                ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.genieRecap.submissions_count < _vm.submissions) ? _c('button', {
    staticClass: "sample flex space-x-2.5 items-center px-5 py-2 bg-pink-50 border border-solid border-pink-300 rounded text-xs text-pinky font-semibold hover:bg-pinky-new_light",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.regenerateSummary.apply(null, arguments)
      }
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader -m-1.5"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.loading ? _vm.genieRecap.recap_created ? 'Generating...' : 'Regenerating...' : 'Regenerate'))])]) : _vm._e()])])])])]), _vm._v(" "), _c('CommentsTab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.comments_tab),
      expression: "comments_tab"
    }],
    key: ("recap-comment-" + (_vm.genieRecap.id)),
    staticClass: "mt-5",
    attrs: {
      "fromGenieRecap": true,
      "recapCommentsFromService": _vm.recap_comments,
      "isFromNotification": _vm.is_from_notification
    }
  }), _vm._v(" "), (_vm.comments_tab) ? _c('div', {
    staticClass: "my-6 flex justify-center"
  }, [_c('button', {
    key: "collapse",
    staticClass: "bg-white text-blueGray-500 hover:border-blueGray-700 hover:text-blueGray-700 border border-solid border-blueGray-500 rounded-full px-4 py-1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.collapseGenieCard.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-up"
  })])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-034c55aa!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/genieRecap/genieRecap.vue
// module id = 1099
// module chunks = 61